import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@services/settings.service';
import { UrlService } from '@services/url.service';
import {
  DataViewState,
  DataViewUserViewsSchema,
  DataViewViews,
  DATAVIEW_CONFIG_VERSION,
  ViewPreset,
} from '@shared/dataview/core/dataview-types';
import { IUser } from '@shared/models/user.model';
import { map, Observable } from 'rxjs';

export const USER_VIEWS_V4_ATTRIBUTE = (page: string) => `dataview4_${page}_views`;

function userSubject(user: IUser): string {
  return `user-username:${user.username}`;
}

@Injectable({ providedIn: 'root' })
export class DataViewUserViewsService {
  private readonly http = inject(HttpClient);
  private readonly settingsService = inject(SettingsService);
  private readonly url = inject(UrlService);

  load(pageName: string): Observable<DataViewViews> {
    return this.http.get<DataViewViews>(this.url.DATAVIEW_VIEWS_URL.replace('{page}', pageName));
  }

  save(pageName: string, user: IUser, config: DataViewUserViewsSchema): Observable<unknown> {
    return this.settingsService
      .saveSettings(userSubject(user), USER_VIEWS_V4_ATTRIBUTE(pageName), {
        ...config,
        configVersion: DATAVIEW_CONFIG_VERSION,
      })
      .pipe(
        map(result => {
          if (result instanceof Error || result instanceof HttpErrorResponse) throw result;
          return result;
        }),
      );
  }

  buildSaveable(options: { views: Array<ViewPreset<DataViewState>>; favouriteColumnIds: string[] }): DataViewUserViewsSchema {
    return {
      configVersion: DATAVIEW_CONFIG_VERSION,
      views: options.views.filter(view => view.isCustom),
      pinnedViewIds: [...new Set(options.views.filter(view => view.isPinned).map(view => view.id))],
      unpinnedDefaultViewIds: options.views.filter(view => !view.isPinned && !view.isCustom).map(view => view.id),
      favouriteColumnIds: options.favouriteColumnIds,
    };
  }
}
